import React from 'react';
import NewVMStep3 from './NewVSStep3';

const NewVSStep3Container = ({ appsData, formikProp }) => {
  return <NewVMStep3 appsData={appsData} formikProp={formikProp} />;
};
export default NewVSStep3Container;
